import { camelToTitle } from "~/helpers/camelToTitle";
import i18n from "~/i18n/i18n";

const LINES_KEY_PREFIX = "common:grid.conditionalFormatting.savedRules.lines";

const operatorLabel = (operator: ConditionType | undefined): string =>
	operator ? i18n.t(`common:grid.conditionalFormatting.conditionTypes.${operator}`) : "";

const describeSavedRuleCondition = (condition: ConditionDef, ruleType: RuleType): string => {
	const column = camelToTitle(condition.column);
	switch (ruleType) {
		case "value":
			return i18n.t(`${LINES_KEY_PREFIX}.${condition.value2 ? "range" : "compare"}`, {
				column,
				operator: operatorLabel(condition.type?.[condition.dataType]),
				value: condition.value ?? "",
				value2: condition.value2
			});
		case "ranking":
			return i18n.t(`${LINES_KEY_PREFIX}.compare`, {
				column,
				operator: operatorLabel(condition.type?.ranking),
				value: condition.value ?? ""
			});
		case "average":
			return i18n.t(`${LINES_KEY_PREFIX}.average`, { column, operator: operatorLabel(condition.type?.average) });
		case "unique":
			return i18n.t(`${LINES_KEY_PREFIX}.unique`, { column, operator: operatorLabel(condition.type?.unique) });
		default:
			return "";
	}
};

export default describeSavedRuleCondition;
